import {loadLayerInfoInfoItems} from "@/helpers/layer/info/layer-info-info-helper";
import {initHideButton, showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";

export function loadCesiumInfo(feature) {
    let innerHtml =  `<div class="info-menu-info-header info-menu-info-draggable">`
        innerHtml += ``

    innerHtml +=  `
    <div class="card mb-3 mr-3 bg-lighter pb-2" style="border-radius: calc(.125rem - 0px) calc(.125rem - 0px) 0 0;min-height:460px;max-height: calc(100vh - 209px);overflow: auto;-webkit-overflow-scrolling: touch;">

            <div class="card-header p-2">
                <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-domain-id="13" data-presentation-id="6" data-form-id="8" data-bs-target="#collapseInfo0-2-0" data-bs-toggle="collapse" aria-expanded="true"> 
                   Informatie
                   <div class="collapse-icon"></div>
                 </a>  
                 <div class="float-right">
                    <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu position-relative" style="margin:-5px 15px 0 0">
                        <span class="fa fa-times"></span>
                        </button>
                 </div>
            </div>     
            <div class="card-body mt-3">

`

    const propertyIds = feature.getPropertyIds();
    const length = propertyIds.length;
    for (let i = 0; i < length; ++i) {
        const propertyId = propertyIds[i];



        const values = feature.getProperty(propertyId)
        if(typeof values === 'object' && values !== null) {
            for (const [key, value] of Object.entries(values)) {
                innerHtml +=
                    `<div class="row">
                    <div class="col-5">` + key + `</div>
                    <div class="col-7">` + value +
                    `</div>
            </div>`
            }
        } else {
            innerHtml +=
                `<div class="row">
                    <div class="col-5">` + propertyId + `</div>
                    <div class="col-7">` + feature.getProperty(propertyId) +
                `</div>
            </div>`
        }

    }

    innerHtml += `</div></div>`

    document.querySelector('layer-info-info').innerHTML = innerHtml

    showLayerInfoButton('layer-info-info', false)

    initHideButton()
}
